import React from 'react';
import { Box, TextField, Button, CircularProgress, Checkbox } from '@material-ui/core';
import MaterialTable from 'material-table';
import localization from 'utils/materialTableLocalization';
import shallow from 'zustand/shallow';
import useProductsOutputManagementStore, { productsOutputManagementStore } from 'stores/productsOutputManagement.store';
import { CartItem } from 'interfaces/productOutputManagement.interface';

export default function ImProductOutputManagementCart() {
  const tableRef = React.createRef<any>();
  const { saveMovement } = useProductsOutputManagementStore();
  const [cartItems, setCartItems, isLoadingSave] = productsOutputManagementStore(
    (state) => [state.cartItems, state.setCartItems, state.isLoadingSave],
    shallow
  );

  return (
    <>
      <MaterialTable
        title="Productos a descontar"
        tableRef={tableRef}
        isLoading={isLoadingSave}
        columns={[
          {
            field: 'order',
            title: 'order',
            hidden: true
          },
          {
            title: 'Producto',
            field: 'name',
            sorting: false
          },
          {
            title: 'SKU',
            field: 'sku',
            sorting: false
          },
          {
            title: 'Descuenta WP?',
            field: 'discountsWp',
            sorting: false,
            render: (cartItem: CartItem) => {
              return (
                <Checkbox
                  value={cartItem.discountsWp}
                  onChange={(_e, checked) => {
                    setCartItems(
                      cartItems.map((ci) => {
                        if (ci.sku == cartItem.sku) {
                          ci.discountsWp = checked;
                        }

                        return ci;
                      })
                    );
                  }}
                />
              );
            }
          },
          {
            title: 'Cantidad',
            field: 'quantity',
            sorting: false,
            render: (cartItem: CartItem) => {
              return (
                <TextField
                  variant="outlined"
                  margin="dense"
                  style={{ width: '50%' }}
                  value={cartItem.quantity}
                  type="number"
                  onChange={(e) => {
                    const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                    const itemsToCheck = [...cartItems];

                    const withoutItemToUpdate = itemsToCheck.map((ci) => {
                      if (ci.sku == cartItem.sku) {
                        ci.quantity = Number(onlyNums);
                      }
                      return ci;
                    });

                    setCartItems([...withoutItemToUpdate]);
                  }}
                />
              );
            }
          }
        ]}
        data={cartItems}
        localization={localization}
        options={{
          draggable: false,
          pageSize: 5,
          pageSizeOptions: [5, 20, 30],
          padding: 'dense',
          actionsColumnIndex: -1
        }}
        actions={[
          {
            icon: 'delete',
            iconProps: { color: 'secondary' },
            tooltip: 'Quitar producto de la lista',
            onClick: (event, rowData) => {
              const cartItemToDelete = rowData as CartItem;
              setCartItems(cartItems.filter((i) => i.sku != cartItemToDelete.sku));
            }
          }
        ]}
      />
      <Box display="flex" justifyContent="center">
        <Button
          type="button"
          variant="contained"
          color="primary"
          disabled={isLoadingSave}
          onClick={() => saveMovement()}
          style={{ marginTop: 10 }}
        >
          {isLoadingSave ? <CircularProgress size={20} /> : ''} Guardar
        </Button>
      </Box>
    </>
  );
}
